// Loop Engineering QA and Refinement for JustTheDictionary

import { buildDictionaryContext } from '../contexts/dictionary-context';

/**
 * Loop Manager for Dictionary queries.
 * Determines if the initial dictionary definition was sufficient, or if the system
 * needs to iterate (loop) to fetch more context (e.g., usage examples, synonyms) 
 * if the user's prompt suggests confusion.
 */
export async function executeDictionaryLoop(seedPrompt: string, initialResponse?: string): Promise<string> {
    console.log(`[Dictionary Loop Engine] Evaluating definition sufficiency for: "${seedPrompt}"`);
    
    // Step 1: Base Context Fetch (Version 1)
    let context = await buildDictionaryContext(seedPrompt);
    
    // Step 2: Quality Control / Loop Evaluation
    const userIsConfused = seedPrompt.toLowerCase().includes("i don't get it") || seedPrompt.toLowerCase().includes("example");
    
    if (userIsConfused) {
        // The "Break It" Condition failed. The user needs more context.
        // We simulate looping back to the harness to pull deep-dive examples.
        context += `\n[LOOP-ENGINEERING INJECTION: The user is struggling to understand this slang. Provide 3 distinct, highly contextual examples of it being used in a sentence.]\n`;
    }

    return context;
}
